import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RevealDropdown, {
  RevealDropdownTrigger,
} from "components/base/RevealDropdown";
import { Dropdown } from "react-bootstrap";
import classNames from "classnames";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import { dateFormatter, formatFileSize } from "helpers/utils";
import { Link } from "react-router-dom";

const FileListItem = ({
  attachment,
  className,
  dropdownControl = true,
  deleteAttachment,
}: any) => {
  return (
    <div className={classNames(className, "border-bottom py-3")}>
      <div>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <div className="d-flex align-items-center">
              <FontAwesomeIcon
                // icon={
                //   attachment.mimeType === "image"
                //     ? faImage
                //     : attachment.mimeType === "zip"
                //       ? faFileZipper
                //       : faFileLines
                // }
                icon={faFileLines}
                className="me-2 fs-5 text-body-tertiary"
              />
              <div>
                <a
                  target="_blank"
                  href={attachment.attachment_link}
                  className="text-body-highlight mb-0 lh-1"
                >
                  {attachment?.attachment_title.replace(/[^\x20-\x7E]/g, '')}
                </a>
                <div className="d-flex fs-9 text-body-tertiary flex-wrap">
                  {attachment.attachment_size && (
                    <>
                      <span>{formatFileSize(attachment.attachment_size)}</span>
                      <span className="text-body-quaternary mx-1">| </span>
                    </>
                  )}
                  <span className="text-nowrap">
                    {dateFormatter(attachment.created_on)}
                  </span>
                </div>
              </div>
            </div>
            {/* {attachment.attachment_link && (
              <img
                src={attachment.attachment_link}
                alt={attachment.attachment_title}
                className="rounded-2 img-fluid"
                style={{
                  maxWidth: "100px",
                }}
              />
            )} */}
          </div>
          {dropdownControl && (
            <RevealDropdownTrigger>
              <RevealDropdown>
                <Dropdown.Item
                  className="text-danger"
                  onClick={() => deleteAttachment(attachment.id)}
                >
                  Delete
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  target="_blank"
                  to={attachment.attachment_link}
                >
                  Download
                </Dropdown.Item>
              </RevealDropdown>
            </RevealDropdownTrigger>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileListItem;
